/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './fraud_taxonomy';
import '../riskevaluation/external/external';
import './risk_manager_enrollment_status';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "risk": {
        "nested": {
          "RiskMetadata": {
            "fields": {
              "fraudTaxonomy": {
                "type": ".squareup.risk.FraudTaxonomy",
                "id": 1,
                "rule": "repeated"
              },
              "externalRiskEvaluationDetails": {
                "type": ".squareup.riskevaluation.external.EvaluationDetails",
                "id": 3,
                "rule": "optional"
              },
              "riskManagerEnabled": {
                "type": "bool",
                "id": 4,
                "rule": "optional"
              },
              "riskManagerEnrollmentStatus": {
                "type": ".squareup.risk.RiskManagerEnrollmentStatus",
                "id": 5,
                "rule": "optional"
              },
              "riskCheckResult": {
                "type": ".squareup.risk.RiskCheckResult",
                "id": 9,
                "rule": "optional"
              },
              "blockedIdentifiers": {
                "type": ".squareup.risk.BlockType",
                "id": 6,
                "rule": "repeated"
              },
              "blockTokens": {
                "type": "string",
                "id": 7,
                "rule": "repeated"
              },
              "allowTokens": {
                "type": "string",
                "id": 8,
                "rule": "repeated"
              },
              "isBlocklistTimeout": {
                "type": "bool",
                "id": 10,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "backstopMetadata": {
                "type": ".squareup.risk.BackstopMetadata",
                "id": 11,
                "rule": "optional"
              }
            }
          },
          "BackstopMetadata": {
            "fields": {
              "isBackstopEvaluation": {
                "type": "bool",
                "id": 1,
                "rule": "optional"
              },
              "backstopRuleNames": {
                "type": "string",
                "id": 2,
                "rule": "repeated"
              }
            }
          },
          "BlockType": {
            "values": {
              "DO_NOT_USE": 0,
              "MERCHANT_BLOCKED_CARD": 1,
              "SQUARE_INTERNAL_BLOCKED_IP": 2,
              "SQUARE_INTERNAL_BLOCKED_BROWSER_FINGERPRINT": 3,
              "MERCHANT_BLOCKED_EMAIL": 4,
              "MERCHANT_BLOCKED_IP": 5,
              "SQUARE_INTERNAL_BLOCKED_CARD": 6,
              "SQUARE_INTERNAL_BLOCKED_EMAIL": 7,
              "SQUARE_INTERNAL_BLOCKED_PAN": 8,
              "SQUARE_INTERNAL_BLOCKED_BIN": 9,
              "SQUARE_INTERNAL_BLOCKED_AVT": 10,
              "SQUARE_INTERNAL_BLOCKED_JA3_HASH": 11
            }
          },
          "RiskCheckResult": {
            "values": {
              "DEFAULT_RISK_CHECK_RESULT_DO_NOT_USE": 0,
              "APPROVED": 1,
              "REJECTED": 2,
              "SKIPPED": 3,
              "TIMED_OUT": 4,
              "UNKNOWN_ERROR": 5
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.risk?.nested?.RiskMetadata && !$root.nested?.squareup?.nested?.risk?.nested?.BackstopMetadata && !$root.nested?.squareup?.nested?.risk?.nested?.BlockType && !$root.nested?.squareup?.nested?.risk?.nested?.RiskCheckResult) {
  $root.addJSON(jsonData);
}

/**
 * Information about payments for risk purposes
 *
 * SOURCE RiskMetadata @ squareup/risk-metadata-protos/risk_metadata.proto at 15:1
 */
export const RiskMetadata = $root.lookupType('squareup.risk.RiskMetadata');
fixType(RiskMetadata);
Builder.createAndAttachToType(RiskMetadata);
/**
 * Information about backstop processing for risk evaluation
 *
 * SOURCE BackstopMetadata @ squareup/risk-metadata-protos/risk_metadata.proto at 78:1
 */
export const BackstopMetadata = $root.lookupType('squareup.risk.BackstopMetadata');
fixType(BackstopMetadata, {
  isBackstopEvaluation: {
    required: true
  }
});
Builder.createAndAttachToType(BackstopMetadata);
/**
 * Type of identifier blocked by pre-auth blocklist
 *
 * SOURCE BlockType @ squareup/risk-metadata-protos/risk_metadata.proto at 94:1
 */
export const BlockType = $root.lookupEnum('squareup.risk.BlockType').values;
/**
 * High level result of a risk check.
 *
 * SOURCE RiskCheckResult @ squareup/risk-metadata-protos/risk_metadata.proto at 112:1
 */
export const RiskCheckResult = $root.lookupEnum('squareup.risk.RiskCheckResult').values;